const audio = {
    namespaced: true,
    state: {
        isAudioBarFirstShow: true,
        audioList: [],
        audioCurrentIndex: -1,
        audioCurrentTime: 0,
        duration: 0,
        xPlayer: null, //喜马拉雅播放器
        fPlayer: null, //封面播放器
        isAudioLoading: false,
        isPause: false, //音乐是否暂停
    },
    mutations: {
        setPause(state, data){
            state.isPause = data
        },
        setXPlayer(state, data){
            state.xPlayer = data
        },
        setFPlayer(state, data){
            state.fPlayer = data
        },
        setAudioLoading(state, data){

            state.isAudioLoading = data
        },
        setAudioList(state, data){
            state.audioList = data
        },
        setAudioCurrentIndex(state, data){
            state.audioCurrentIndex = data
        },
        setAudioCurrentTime(state, data){
            state.audioCurrentTime = data
        },
        setAudioBarFirstShow(state, data){
            state.isAudioBarFirstShow = data
        },
        setDuration(state, data){
            // console.log("设置公用播放时长===",data)
            state.duration = data
        },
    },
    actions: {}
}
 export default audio
